<template>
  <div class="store-manage-page">
    <div class="page-header">
      <div class="page-header__info">
        <h2 class="page-title">订单管理</h2>
        <p class="page-desc">查看订单、处理发货与用户留言</p>
      </div>
    </div>

    <div class="manage-card">
      <el-tabs v-model="activeName" class="manage-tabs" @tab-click="tabClick">
        <el-tab-pane v-for="(tab,i) in tabs" :key="i" :label="tab" :name="tab"/>
      </el-tabs>

      <div class="filter-bar">
        <el-form ref="params" :model="params" class="filter-form" inline @submit.native.prevent="search">
          <el-form-item label="订单 ID">
            <el-input v-model.number="params.id" clearable placeholder="订单 ID"/>
          </el-form-item>
          <el-form-item label="订单号">
            <el-input v-model="params.orderNo" clearable placeholder="订单号"/>
          </el-form-item>
        </el-form>
        <div class="filter-actions">
          <el-button icon="el-icon-search" type="primary" @click="search()">搜索</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset()">重置</el-button>
        </div>
      </div>

      <div class="store-manage-page__table">
        <el-table v-loading="loadTable" :data="records" size="small" stripe>
          <el-table-column fixed label="ID" prop="id" width="72"/>
          <el-table-column label="订单号" min-width="160" prop="orderNo" show-overflow-tooltip/>
          <el-table-column label="收货人" min-width="100">
            <template slot-scope="{ row }">
              {{ row.address.userName }}
            </template>
          </el-table-column>
          <el-table-column label="联系电话" min-width="120">
            <template slot-scope="{ row }">
              {{ row.address.telNumber }}
            </template>
          </el-table-column>
          <el-table-column label="收货地址" min-width="220" show-overflow-tooltip>
            <template slot-scope="{ row }">
              {{ formatAddress(row.address) }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="数量" prop="size" width="72"/>
          <el-table-column v-if="activeName==='全部' || activeName==='待付款'" align="center" label="剩余时间" width="110">
            <template slot-scope="{ row, $index }">
              <span v-if="row.state==='0' && row.countdownTime>0">
                <el-statistic
                    ref="statistic"
                    :value="row.countdownTime"
                    format="HH:mm:ss"
                    time-indices
                    @finish="countdownTimeFinish($index)"
                />
              </span>
              <span v-else class="item-info__meta">—</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态" width="96">
            <template slot-scope="{ row }">
              <el-tag :type="getOrderStateType(row)" effect="light" size="mini">
                {{ getOrderStateText(row) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="160" prop="createdTime" show-overflow-tooltip/>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="{ row }">
              <div class="row-actions">
                <el-button size="mini" type="text" @click="onShowCars(row)">订单详情</el-button>
                <el-button v-if="row.state==='1'" size="mini" type="text" @click="onShowShipments(row)">发货</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-footer">
        <page :current="current" :size="size" :total="total"/>
      </div>
    </div>

    <el-dialog
        :visible.sync="showCars"
        center
        title="订单详情"
        width="600px"
        custom-class="order-detail-dialog">
      <div ref="orderDetailContent" class="order-detail-content">
        <!-- 订单头部信息 -->
        <div class="order-detail-header">
          <div class="order-detail-user">
            <el-avatar
                v-if="headImage"
                :size="48"
                :src="headImage"
                fit="cover"/>
            <el-avatar v-else :size="48" icon="el-icon-user-solid"/>
            <div class="order-detail-user-info">
              <div class="order-detail-user-name">{{ nickName || '—' }}</div>
              <div class="order-detail-user-label">买家</div>
            </div>
          </div>
          <div class="order-detail-price">
            <div class="order-detail-price-label">订单总价</div>
            <div class="order-detail-price-value">{{ totalPrice }} 佣金</div>
          </div>
        </div>

        <!-- 订单信息 -->
        <div class="order-detail-section">
          <div class="order-detail-section-title">订单信息</div>
          <div class="order-detail-info">
            <div class="order-detail-info-row">
              <span class="order-detail-info-label">订单号：</span>
              <span class="order-detail-info-value">{{ orderNo }}</span>
            </div>
            <div class="order-detail-info-row">
              <span class="order-detail-info-label">联系电话：</span>
              <span class="order-detail-info-value">{{ orderPhone }}</span>
            </div>
            <div class="order-detail-info-row">
              <span class="order-detail-info-label">收货地址：</span>
              <span class="order-detail-info-value">{{ orderAddress }}</span>
            </div>
            <div class="order-detail-info-row">
              <span class="order-detail-info-label">订单状态：</span>
              <span class="order-detail-info-value">{{ orderState }}</span>
            </div>
            <div class="order-detail-info-row">
              <span class="order-detail-info-label">创建时间：</span>
              <span class="order-detail-info-value">{{ orderCreatedTime }}</span>
            </div>
          </div>
        </div>

        <!-- 商品列表 -->
        <div class="order-detail-section">
          <div class="order-detail-section-title">商品信息</div>
          <div class="order-detail-items">
            <div v-for="(e,i) in cars" :key="i" class="order-detail-item">
              <div class="order-detail-item-main">
                <el-image
                    v-if="e.coverImg"
                    :src="fileBaseUrl+e.coverImg"
                    :preview-src-list="[fileBaseUrl+e.coverImg]"
                    fit="cover"
                    class="order-detail-item-img"/>
                <div v-else class="order-detail-item-img order-detail-item-img--placeholder">
                  <i class="el-icon-picture-outline"></i>
                </div>
                <div class="order-detail-item-info">
                  <div class="order-detail-item-name">{{ e.productName }}</div>
                  <div class="order-detail-item-spec">{{ e.specificationName }}</div>
                  <div class="order-detail-item-price-row">
                    <span class="order-detail-item-price">{{ e.price }} 佣金</span>
                    <span class="order-detail-item-num">× {{ e.num }}</span>
                  </div>
                </div>
              </div>
              <div class="order-detail-item-actions">
                <el-tag v-if="e.state==='2'" effect="plain" size="mini" type="success">已发货</el-tag>
                <el-tag v-if="e.state==='3'" effect="plain" size="mini" type="info">已收货</el-tag>
                <el-button v-if="!savingImage && e.state==='1'" size="mini" type="warning" @click="onShowShipmentsCar(e)">发货</el-button>
                <el-button v-if="!savingImage && e.state!=='0' && e.state!=='1'" size="mini" @click="onShowEditShipmentsCar(e)">修改快递</el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 用户留言 -->
        <div v-if="message" class="order-detail-section">
          <div class="order-detail-section-title">用户留言</div>
          <div class="order-detail-message">{{ message }}</div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="saveOrderAsImage" icon="el-icon-download" type="primary" plain>保存为图片</el-button>
        <el-button @click="showCars = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="确认发货"
        :visible.sync="showShipmentsCar"
        width="35%"
        center>

      <el-form label-position="left" label-width="80px" :model="shipmentsCar" ref="shipmentsCarForm">
        <el-form-item label="快递" prop="expressage"
                      :rules="[
                        {required: true, message: '请选择快递', trigger: 'blur'}
                        ]">
          <el-select v-model="shipmentsCar.expressage" clearable placeholder="快递">
            <el-option
                v-for="item in expressages"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运单号" prop="waybillNumber">
          <el-input v-model="shipmentsCar.waybillNumber" maxlength="50"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showShipmentsCar = false">取 消</el-button>
        <el-button type="primary" @click="doShipmentsCar('shipmentsCarForm')">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="修改快递"
        :visible.sync="showEditShipmentsCar"
        width="35%"
        center>

      <el-form label-position="left" label-width="80px" :model="shipmentsCar" ref="editShipmentsCarForm">
        <el-form-item label="快递" prop="expressage"
                      :rules="[
                        {required: true, message: '请选择快递', trigger: 'blur'}
                        ]">
          <el-select v-model="shipmentsCar.expressage" clearable placeholder="快递">
            <el-option
                v-for="item in expressages"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运单号" prop="waybillNumber">
          <el-input v-model="shipmentsCar.waybillNumber" maxlength="50"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditShipmentsCar = false">取 消</el-button>
        <el-button type="primary" @click="doEditShipmentsCar('editShipmentsCarForm')">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="确认全部发货"
        :visible.sync="showShipments"
        width="35%"
        center>

      <el-form label-position="left" label-width="80px" :model="shipments" ref="shipmentsForm">
        <el-form-item label="快递" prop="expressage"
                      :rules="[
                        {required: true, message: '请选择快递', trigger: 'blur'}
                        ]">
          <el-select v-model="shipments.expressage" clearable placeholder="快递">
            <el-option
                v-for="item in expressages"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运单号" prop="waybillNumber">
          <el-input v-model="shipments.waybillNumber" maxlength="50"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showShipments = false">取 消</el-button>
        <el-button type="primary" @click="doShipments('shipmentsForm')">提 交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import Page from "@/components/Page.vue";
import page from "@/api/store/StoreOrder/page";
import {strToDate} from "@/utils/time";
import shipments from "@/api/store/StoreOrder/shipments";
import shipmentsCar from "@/api/store/ShopCar/shipments";
import getCars from "@/api/store/StoreOrder/getCars";
import {Message} from "element-ui";
import editShipments from "@/api/store/ShopCar/editShipments";
import html2canvas from "html2canvas";

export default {
  name: "StoreOrderManage",
  components: {Page},
  data() {
    return {
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      current: 1,
      size: 10,
      total: 0,

      loadTable: false,
      records: [],
      tabs: ['全部', '待付款', '待发货', '待收货', '已收货', '已取消'],
      activeName: '全部',
      params: {
        id: undefined,
        orderNo: undefined,
        state: undefined,
      },

      showCars: false,
      cars: [],
      nickName: undefined,
      headImage: undefined,
      totalPrice: 0,
      orderId: undefined,
      orderNo: undefined,
      orderPhone: undefined,
      orderAddress: undefined,
      orderState: undefined,
      orderCreatedTime: undefined,
      savingImage: false,

      showMessage: false,
      message: undefined,

      showShipmentsCar: false,
      showEditShipmentsCar: false,
      shipmentsCar: {},
      expressages: [
        {
          value: '无',
          label: '自配'
        },
        {
          value: 'wx6885acbedba59c14',
          label: '三方快递'
        },
      ],

      showShipments: false,
      shipments: {},

    }
  },
  computed: {},
  methods: {
    formatAddress(address) {
      if (!address) return '—'
      const parts = [
        address.provinceName,
        address.cityName,
        address.countyName,
        address.streetName,
        address.detailInfoNew,
      ].filter(Boolean)
      return parts.join(' ')
    },
    getOrderStateText(row) {
      if (row.state === '0' && row.expireTimeNum > 0) return '待付款'
      if (row.state === '1') return '待发货'
      if (row.state === '2') return '待收货'
      if (row.state === '3') return '已收货'
      if (row.state === '4' || (row.state === '0' && row.expireTimeNum <= 0)) return '已取消'
      if (row.state === '5') return '退款中'
      if (row.state === '6') return '已退款'
      if (row.state === '7') return '退款失败'
      return '未知'
    },
    getOrderStateType(row) {
      const text = this.getOrderStateText(row)
      const map = {
        '待付款': 'warning',
        '待发货': '',
        '待收货': '',
        '已收货': 'success',
        '已取消': 'info',
        '退款中': 'warning',
        '已退款': 'info',
        '退款失败': 'danger',
      }
      return map[text] || 'info'
    },
    getCarsByOrderId() {
      getCars(this.orderId).then(res => {
        let cars = res.data
        let totalPrice = 0
        for (let i = 0; i < cars.length; i++) {
          totalPrice += cars[i].num * cars[i].price
        }
        this.totalPrice = totalPrice
        if (cars.length === 0) {
          this.nickName = undefined
          this.headImage = undefined
        } else {
          this.nickName = cars[0].nickName
          this.headImage = this.fileBaseUrl + cars[0].headImage
        }
        this.cars = cars
      })
    },
    onShowCars(row) {
      this.orderId = row.id
      this.orderNo = row.orderNo
      this.orderPhone = row.address?.telNumber || '—'
      this.orderAddress = this.formatAddress(row.address)
      this.orderState = this.getOrderStateText(row)
      this.orderCreatedTime = row.createdTime
      this.message = row.message
      this.showCars = true
      this.getCarsByOrderId()
    },
    onShowShipmentsCar(car) {
      this.showShipmentsCar = true
      this.shipmentsCar = {id: car.id}
    },
    doShipmentsCar(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          shipmentsCar(this.shipmentsCar).then(res => {
            if (res.code === 1) {
              Message({message: '成功', type: "success", duration: 3000})
              this.showShipmentsCar = false
              this.fetchData()
              this.getCarsByOrderId()
            } else {
              Message({message: "error", type: "error", duration: 3000})
            }
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    onShowEditShipmentsCar(car) {
      this.showEditShipmentsCar = true
      this.shipmentsCar = {id: car.id, expressage: car.expressage, waybillNumber: car.waybillNumber}
    },
    doEditShipmentsCar(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          editShipments(this.shipmentsCar).then(res => {
            if (res.code === 1) {
              Message({message: '成功', type: "success", duration: 3000})
              this.showEditShipmentsCar = false
              this.fetchData()
              this.getCarsByOrderId()
            } else {
              Message({message: "error", type: "error", duration: 3000})
            }
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    onShowShipments(data) {
      this.showShipments = true
      this.shipments = {id: data.id}
    },
    doShipments(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          shipments(this.shipments).then(res => {
            if (res.code === 1) {
              this.$notify({title: '成功', message: '已发货', type: 'success'});
              this.showShipments = false
              this.fetchData()
            } else {
              this.$notify({title: '失败', message: '操作失败', type: 'error'});
            }
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    countdownTimeFinish(i) {
      this.records[i].countdownTime = 0
    },
    tabClick(e) {
      this.activeName = e.label
      let state = e.index - 1
      if (state === -1) {
        this.params.state = undefined
      } else {
        this.params.state = state + ''
      }
      this.reset()
    },
    pageOrder() {
      this.loadTable = true
      page(this.current, this.size, this.params).then(res => {
        let records = res.data.data
        let nowTimeNum = new Date().getTime()
        for (let i = 0; i < records.length; i++) {
          let e = records[i]
          let expireTimeStr = e.expireTime
          e.countdownTime = strToDate(expireTimeStr)
          e.expireTimeNum = e.countdownTime.getTime() - nowTimeNum
          e.size = 0
          let shopCars = e.shopCars
          for (let j = 0; j < shopCars.length; j++) {
            let car = shopCars[j]
            e.size += car.num
          }
        }
        this.records = records
        this.total = res.data.total
      }).finally(() => {
        this.loadTable = false
      })
    },
    search() {
      this.current = 1
      this.fetchData()
    },
    reset() {
      this.current = 1
      this.params.id = undefined
      this.params.orderNo = undefined
      this.fetchData()
    },
    fetchData() {
      this.pageOrder()
    },
    saveOrderAsImage() {
      const target = this.$refs.orderDetailContent
      if (!target) return
      this.savingImage = true
      this.$nextTick(() => {
        html2canvas(target, {
          useCORS: true,
          backgroundColor: '#ffffff',
          scale: 2,
        }).then(canvas => {
          const link = document.createElement('a')
          link.download = `订单详情_${this.orderId || Date.now()}.png`
          link.href = canvas.toDataURL('image/png')
          link.click()
        }).catch(() => {
          Message({message: '保存图片失败', type: 'error', duration: 3000})
        }).finally(() => {
          this.savingImage = false
        })
      })
    },
  },

  mounted() {
    this.fetchData()
  },

}
</script>

<style lang="scss" scoped>
@import '../store-manage-page.scss';

.order-detail-content {
  padding: 0 4px;
}

.order-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8edf3 100%);
  border-radius: 12px;
  margin-bottom: 20px;
}

.order-detail-user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.order-detail-user-info {
  display: flex;
  flex-direction: column;
}

.order-detail-user-name {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.order-detail-user-label {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

.order-detail-price {
  text-align: right;
}

.order-detail-price-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.order-detail-price-value {
  font-size: 22px;
  font-weight: 700;
  color: #f56c6c;
}

.order-detail-section {
  margin-bottom: 20px;
}

.order-detail-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  padding-bottom: 10px;
  margin-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
}

.order-detail-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.order-detail-item {
  padding: 12px;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.order-detail-item-main {
  display: flex;
  gap: 12px;
  margin-bottom: 8px;
}

.order-detail-item-img {
  width: 64px;
  height: 64px;
  border-radius: 6px;
  flex-shrink: 0;
  overflow: hidden;

  &--placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f2f5;
    color: #c0c4cc;
    font-size: 24px;
  }
}

.order-detail-item-info {
  flex: 1;
  min-width: 0;
}

.order-detail-item-name {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-detail-item-spec {
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
}

.order-detail-item-price-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.order-detail-item-price {
  font-size: 14px;
  font-weight: 600;
  color: #f56c6c;
}

.order-detail-item-num {
  font-size: 12px;
  color: #909399;
}

.order-detail-item-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.order-detail-message {
  padding: 12px 16px;
  background: #fdf6ec;
  border-radius: 8px;
  border: 1px solid #faecd8;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}
</style>
